export { setPageContextCurrent };
export { getPageContextCurrent };
import { getGlobalObject } from './utils.js';
const globalObject = getGlobalObject('client-routing-runtime/getPageContextCurrent.ts', {
    pageContextCurrent: null
});
function getPageContextCurrent() {
    const { pageContextCurrent } = globalObject;
    return pageContextCurrent;
}
function setPageContextCurrent(pageContextCurrent) {
    globalObject.pageContextCurrent = pageContextCurrent;
}
